export default "__VITE_ASSET__BFPmuIUg__"